<template>
  <div class="pt-side-component-nav">
    <div class="pt-side-component--top">
      <router-link to="/" ><img :src="logoUrl" alt="" class="logo"></router-link>
    </div>
    <wt-menu-tree :config="config" class="menu-tree"></wt-menu-tree>
    <!-- <img v-if="hasCreatelabOrder" src="@/assets/images/bottom_logo.png" alt="" class="side-component-nav__img--background"> -->
    <!-- <el-button type="primary">test</el-button> -->
  </div>
</template>

<script>
import { menuConfig } from './menu-config.js'
const PERM_CONTRACT_MANAGEMENT = 'PERM_CONTRACT_MANAGEMENT'

export default {
  name: 'pt-side-component-nav',
  computed: {
    hasCreatelabOrder () {
      return this.$auth.user() && this.$auth.user().permissions && this.$hasPermissions(this.$auth.user().permissions, PERM_CONTRACT_MANAGEMENT)
    },
    logoUrl () {
      return this.$store.state.saasConfig.menuLogoUrl
    }
  },
  data () {
    return {
      // config: menuConfig
      config: this.$store.state.menuList
    }
  },
  watch: {
    '$store.state.menuList': {
      handler: function (val) {
        this.config = val
      },
      immediate: true
    }
  }

}
</script>

<style  lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-side-component-nav{
  position: relative;
  overflow-y: hidden;
  min-height: 100%;
  padding:10PX 0;
  box-sizing: border-box;
}
img.side-component-nav__img--background{
  position: absolute;
  left: -10px;
  bottom: -40px;
  width: 95%;
  z-index: 1;
}
.pt-side-component--top{
  background-color: #409EFF;
  height: auto;
  width: 2rem;
  position: fixed;
  left: 0;
  top:0px;
  z-index: 99999;
  text-align: center;
  img.logo{
    width: 80%;
    padding: 25PX 0 25PX;
  }
}
// 覆盖默认菜单树样式
.pt-side-component-nav{
    z-index: 11;
    padding-top:170px;
    .pt-menu-tree-item{
      i{
        color: #3D3D3D;
      }
      .el-menu-item{
        color:#3D3D3D;
        &.is-active {
            color: #409eff;
        }
      }
      .el-submenu__title{
        color: #333;
        &:hover{
          background-color: #409EFF;
          color: #fff;
          i{
            color: #fff;
          }
        }
        i{
          color: #333;
        }
      }
      .el-menu--inline .el-menu-item{
        color: #333;
        &.is-active{
          color: #fff !important;
          background-color: #409EFF !important;
        }
        &:hover{
          background-color: #409EFF;
          color: #fff;
          i{
            color: #fff;
          }
        }
      }
      .el-menu-item:focus, .el-menu-item:hover{
        i{
          color: #fff;
        }
        color: #fff !important;
        background-color: #409EFF !important;
      }
    }
}

</style>
